module.exports = __webpack_public_path__ + "static/media/EuVECA-PID.cf4971c4.pdf";